import type {ContextMenuProps, ContextMenuType} from "./ContextMenuManager";
import {AppState} from "@stores/AppState";

export interface ToggleCtxMenuConfig extends Omit<ContextMenuProps, 'getTargetBoundingBox'> {
    type: ContextMenuType;
    getTargetBoundingBox: () => DOMRect;
}

export interface ToggleCtxMenuOptions {
    asAdditional?: boolean;
    closeOthers?: boolean; // applies when asAdditional is true
}

export function toggleContextMenu(
    appState: AppState,
    config: ToggleCtxMenuConfig,
    opts: ToggleCtxMenuOptions = {asAdditional: false, closeOthers: true}
) {
    const keyId = config.id;
    const isOpen = keyId ? appState.isCtxMenuOpen(config.type, keyId) : false;

    if (isOpen) {
        appState.closeContextMenusByType(config.type, keyId);
        return;
    }

    if (opts.asAdditional) {
        appState.addAdditionalContextMenu(config, opts.closeOthers !== false);
    } else {
        appState.setContextMenu(config);
    }
    return;
}

